import React from 'react'
import classNames from 'classnames'
import { Button, Icon, Text, Title } from 'components'
import styles from '../ProposalWizard.module.scss'

const SuccessScreen = ({ onFinish }) => (
  <>
    <div className={styles.successIconBadge}>
      <Icon
        type="circlecheck"
        color="greenColor"
        size={32}
        className={styles.successIconGraphic}
      />
    </div>
    <Title type="h1" fontSize="xlarge" alignCenter>
      Proposta enviada com sucesso!
    </Title>
    <Text fontSize="medium" color="lightBlueColor" alignCenter>
      Recebemos sua proposta e ela seguirá agora para nossa triagem inicial.
      <br />
      Caso ela avance para análise do Vendedor, entraremos em contato com você
      para orientar sobre a realização da caução.
    </Text>
    <div className={styles.trustBox}>
      <Icon type="shield" color="secondColor" size={20} />
      <Text fontSize="small" color="lightBlueColor">
        A caução só é solicitada após a triagem inicial e o valor é
        integralmente devolvido caso o Vendedor não aceite a proposta.
      </Text>
    </div>
    <footer className={classNames(styles.footer, styles.footerCentered)}>
      <Button onClick={onFinish} id="fechar_proposta">
        Voltar para o imóvel
      </Button>
    </footer>
  </>
)

export default React.memo(SuccessScreen)
